import { HashLink } from "react-router-hash-link";
import "../styles/Welcome.scss";

export const Welcome = () => {
  return (
    <article id="welcome" className="row">
      <div className="hero-content">
        <h1>We are Atlanta's premier glass experts</h1>
        <h3>Transforming Spaces with Precision Glass Solutions</h3>
        <div className="actions">
          <HashLink to="#contact" className="btn">
            Contact Us
          </HashLink>
          <HashLink to="#services" className="btn white">
            Learn More
          </HashLink>
        </div>
      </div>
    </article>
  );
};
